
const digest = '4193890a467fcbdcffa686fc753f15b456aff9d71818099a40dc6730daa0ee8f';
const css = `._image_1tyq0_1 {
  display: inline-block;
  position: relative;
  max-width: 100%;
  text-align: center;
}

._imageInline_1tyq0_8 {
  display: inline-block;
  margin: 0.2em;
  max-width: 100%;
}

._imageBlock_1tyq0_14 {
  display: block;
  text-align: center;
  margin: 0.2em;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"image":"_image_1tyq0_1","imageInline":"_imageInline_1tyq0_8","imageBlock":"_imageBlock_1tyq0_14"};
export { css, digest };
  